import { Component, Input, signal } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { PfizerPreTaskTemplateListItem } from '../../../../../../models/forms/pfizer-pre-task-safety-plan/pfizer-form-templates/pfizer-pre-task-template-list-item.model';

@Component({
  selector: 'app-pfizer-template-manager-modal',
  templateUrl: './pfizer-template-manager-modal.component.html',
  styleUrls: ['./pfizer-template-manager-modal.component.css']
})
export class PfizerTemplateManagerModalComponent {
  @Input() templates: PfizerPreTaskTemplateListItem[] = [];
  @Input() canEditTemplates: boolean = false;
  
  constructor(
    private modalController: ModalController,
    private alertController: AlertController
  ) {}

  /**
   * Closes the modal
   */
  dismiss() {
    this.modalController.dismiss();
  }

  /**
   * User selected a template to populate the form
   */
  onSelectTemplate(templateId: string) {
    this.modalController.dismiss({
      action: 'select',
      templateId: templateId
    });
  }

  /**
   * User clicked edit button for a template
   */
  onEditTemplate(templateId: string) {
    this.modalController.dismiss({
      action: 'edit',
      templateId: templateId
    });
  }

  /**
   * User clicked delete button for a template
   */
  async onDeleteTemplate(template: PfizerPreTaskTemplateListItem) {
    const alert = await this.alertController.create({
      header: 'Delete Template',
      message: `Are you sure you want to delete the template "${template.templateTitle}"?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            this.modalController.dismiss({
              action: 'delete',
              templateId: template.id
            });
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * User clicked create new template button
   */
  onCreateNewTemplate() {
    this.modalController.dismiss({
      action: 'create'
    });
  }
}